<template>
    <v-container fluid fill-height px-0 class="main-container container-fixed d-block">
        <div class="content-block">
            <v-flex class="d-flex justify-space-between align-center mx-6">
                <div class="arrow-btn main-text main-text d-inline-flex" @click="back">
                    <div v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')" class="d-inline-flex rotate-90" />
                </div>
                <div class="title-text d-inline-flex">
                    История уведомлений
                </div>
                <div class="d-inline-flex"></div>
            </v-flex>
            <div class="error-container pa-6">
                <v-flex text-center>
                    <div v-html="require('!html-loader!@/assets/images/error.svg')" class="d-inline-flex mb-8" />
                    <div class="common-text text-center">
                        Нет доступных уведоомлений
                    </div>
                </v-flex>
            </div>
        </div>
    </v-container>
</template>

<script>
export default {
    name: "NotificationList",
    methods: {
        back() {
            this.$router.go(-1);
        },
    },
}
</script>

<style lang="scss" scoped>
.error-container {
    width: 100%;
    height: calc(100% - 50px);
    display: flex;
    align-items: center;
}
</style>